module.exports = __webpack_public_path__ + "img/2.df692d79.png";